<template>
  <div class="contain">
    <el-tabs v-model="activeName" @tab-click="inquire">
      <template v-if="activeName == 'restype_payable' || activeName == 'restype_receivable'">
          <div style="font-size: 15px;color: rgb(28 28 28);float: left;margin-top: 3px;">天数间距：</div><el-input type="text" v-model="jgts" placeholder="请输入天数" size="mini" style="width: 80px;margin-bottom:16px" @keyup.enter.native="inquire"></el-input>
      </template>
      <template v-else>
        <el-date-picker
          v-model="date"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          size="mini"
          style="margin-bottom: 16px;margin-right:16px"
          :clearable="false"
          @change="inquire">
        </el-date-picker>
        <el-select v-model="accountType" placeholder="请选择账套" filterable @change="inquire" size="mini" clearable>
          <el-option v-for="(item, index) in dropDown.subjectAccountType2" :key="index" :label="item.dictLabel" :value="item.dictValue"></el-option>
        </el-select>
      </template>
      <el-input type="text" v-model="dealName" placeholder="请输入客户名称" size="mini" style="width: 200px;margin-left: 16px;" @keyup.enter.native="inquire"></el-input>
      <el-input type="text" v-model="selfownName" placeholder="请输入单据负责人" size="mini" style="width: 200px;margin-left: 16px;" @keyup.enter.native="inquire"></el-input>
      <el-button type="primary" size="mini" style="margin-left: 16px;" @click="inquire"><i class="el-icon-search"></i>查询</el-button>
      <el-button type="warning" icon="el-icon-download" size="mini" style="margin-left: 16px;" @click="handleExport">导出</el-button>
      <el-tab-pane label="往来应收" name="receive">
        <el-table
          :data="receiveList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
          v-loading="loading"
          border
          :height="tableHeight"
          v-if="activeName == 'receive'"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.children"
                tooltip-effect="dark"
                style="width: 96%;float:right"
                :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
                border
              >
                <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
                <el-table-column prop="dealName" label="客户" header-align="center"></el-table-column>
                <el-table-column prop="workType" label="活动类型" width="100" align="center" :filters="props.row.filters" :filter-method="filterHandler"></el-table-column>
                <el-table-column prop="workDate" label="单据日期" width="120" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.workDate | filter_handleDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="code" label="单据号码" align="center" width="160">
                  <template slot-scope="scope">
                    <a @click="goProject(scope.row)" class="link">{{scope.row.code}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="debit" label="本期发生金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.debit | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="credit" label="本期已收金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.credit | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="往来金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.amount | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
          <el-table-column prop="dealName" label="客户" header-align="center"></el-table-column>
          <el-table-column prop="ofoworkName" label="活动" align="center" min-width="200">
            <template slot-scope="scope">
              <a @click="goProject(scope.row)" class="link">{{scope.row.ofoworkName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="initialBalance" label="期初余额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.initialBalance | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="debit" label="本期发生金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.debit | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="credit" label="本期已收金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.credit | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="往来金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.amount | comdify('no')}}
            </template>
          </el-table-column>

        </el-table>
      </el-tab-pane>
      <el-tab-pane label="往来应付" name="pay">
        <el-table
          :data="payList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
          v-loading="loading"
          border
          :height="tableHeight"
          v-if="activeName == 'pay'"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.children"
                tooltip-effect="dark"
                style="width: 96%;float:right"
                :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
                border
              >
                <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
                <el-table-column prop="dealName" label="客户" header-align="center"></el-table-column>
                <el-table-column prop="workType" label="活动类型" width="100" align="center" :filters="props.row.filters" :filter-method="filterHandler"></el-table-column>
                <el-table-column prop="workDate" label="单据日期" width="120" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.workDate | filter_handleDate}}
                  </template>
                </el-table-column>
                <el-table-column prop="code" label="单据号码" align="center" width="160">
                  <template slot-scope="scope">
                    <a @click="goProject(scope.row)" class="link">{{scope.row.code}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="debit" label="本期发生金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.debit | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="credit" label="本期已付金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.credit | comdify('no')}}
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="往来金额" align="right" width="150" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.amount | comdify('no')}}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
          <el-table-column prop="dealName" label="客户" header-align="center"></el-table-column>
          <el-table-column prop="ofoworkName" label="活动" align="center" min-width="200">
            <template slot-scope="scope">
              <a @click="goProject(scope.row)" class="link">{{scope.row.ofoworkName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="initialBalance" label="期初余额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.initialBalance | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="debit" label="本期发生金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.debit | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="credit" label="本期已付金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.credit | comdify('no')}}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="往来金额" align="right" width="150" header-align="center">
            <template slot-scope="scope">
              {{scope.row.amount | comdify('no')}}
            </template>
          </el-table-column>

        </el-table>
      </el-tab-pane>
      <el-tab-pane label="应收天数" name="restype_receivable">
        <el-table
          :data="payReport"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
          v-loading="loading"
          border
          v-if="activeName == 'restype_receivable'"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.children"
                tooltip-effect="dark"
                style="width: calc(100% - 50px);margin-left:50px"
                :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
                border
              >
                <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
                <el-table-column label="客户" align="center" prop="deal_name"></el-table-column>
                <el-table-column label="活动" align="center" prop="name"></el-table-column>
                <el-table-column align="center" v-for="(item, index) in columns" :key="index" :label="item.name">
                  <template slot-scope="scope">
                    {{scope.row[item.column] || ''}}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
          <el-table-column label="客户" align="center" prop="deal_name"></el-table-column>
          <el-table-column label="活动" align="center" prop="name"></el-table-column>
          <el-table-column label="合计" align="center" prop="total"></el-table-column>
          <el-table-column align="center" v-for="(item, index) in columns" :key="index" :label="item.name" sortable :prop="item.column">
            <template slot-scope="scope">
              {{scope.row[item.column] || ''}}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="应付天数" name="restype_payable">
        <el-table
          :data="payReport"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
          v-loading="loading"
          border
          v-if="activeName == 'restype_payable'"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.children"
                tooltip-effect="dark"
                style="width: calc(100% - 50px);margin-left:50px"
                :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
                border
              >
                <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
                <el-table-column label="客户" align="center" prop="deal_name"></el-table-column>
                <el-table-column label="活动" align="center" prop="name"></el-table-column>
                <el-table-column align="center" v-for="(item, index) in columns" :key="index" :label="item.name">
                  <template slot-scope="scope">
                    {{scope.row[item.column] || ''}}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
          <el-table-column label="客户" align="center" prop="deal_name"></el-table-column>
          <el-table-column label="活动" align="center" prop="name"></el-table-column>
          <el-table-column label="合计" align="center" prop="total"></el-table-column>
          <el-table-column align="center" v-for="(item, index) in columns" :key="index" :label="item.name" sortable :prop="item.column">
            <template slot-scope="scope">
              {{scope.row[item.column] || ''}}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import url from '@/config/url'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState ({
        dropDown: state => state.dropDown.dropDown
      })
    },
    data() {
      return {
        date: [JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1))),
          JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).name : (new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) > 9 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)))],
        accountType: '',
        dealName: '',
        selfownName: '',
        receiveList: [],
        payList: [],
        loading: true,
        activeName: 'receive',
        tableHeight: window.innerHeight - 245,
        nbzzId:JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1,
        payReport: [],
        columns: [],
        jgts: 30
      }
    },
    async created () {

      await this.$http.get(url.getCbTimeList + '?nbzzId=' + this.nbzzId).then(res => {
        if (res.data.code == 200) {
          this.timeList = res.data.data
          let begin = this.timeList != null && this.timeList.length > 0 ? this.timeList[this.timeList.length-1].name : this.parseTime(new Date().getTime(), '{y}-{m}')
          this.date = [begin, this.parseTime(new Date().getTime(), '{y}-{m}')]
        }
      })
      // 获取账套类型下拉
      if(!this.dropDown.subjectAccountType2){
        this.$http.get(url.getDataList, {params: {type: 'buss_subject_account_type2'}}).then(res => {
          if(res.data.code == 200) {
            this.$store.commit('setSubjectAccountType2', res.data.data)
          }
        })
      }
      this.getReceiveList()
      // window.addEventListener('setItem', ()=> {
      //   // console.log(JSON.parse(sessionStorage.getItem('date')));
      //   this.date = [JSON.parse(sessionStorage.getItem('date')).name, JSON.parse(sessionStorage.getItem('date')).name]
      //   this.nbzzId = JSON.parse(sessionStorage.getItem('date')) ? JSON.parse(sessionStorage.getItem('date')).nbzzId : -1
      //   // this.inquire()
      //   if(this.activeName == 'receive') {
      //     this.getReceiveList()
      //   }else {
      //     this.getPayList()
      //   }
      // })
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 245;
      })
      window.onresize = () => {   //屏幕尺寸变化就重新赋值
        return (() => {
          this.tableHeight = window.innerHeight - 245;
        })()
      }
    },
    methods: {
      getExportTextWidth(value) {
        if (value === undefined || value === null) {
          return 0
        }
        return String(value).split('').reduce((width, char) => {
          return width + (char.charCodeAt(0) > 255 ? 2 : 1)
        }, 0)
      },
      setWorksheetCols(workSheet, tableData) {
        if (!tableData || !tableData.length) {
          return
        }
        const colCount = tableData[0].length
        workSheet['!cols'] = Array.from({ length: colCount }).map((_, colIndex) => {
          const maxWidth = tableData.reduce((width, row) => {
            return Math.max(width, this.getExportTextWidth(row[colIndex]))
          }, 0)
          return {
            wch: Math.min(Math.max(maxWidth + 2, 12), 30)
          }
        })
      },
      formatExportDate(value) {
        if (!value) {
          return ''
        }
        if (typeof value === 'string') {
          if (value.indexOf(' ') > -1) {
            return value.split(' ')[0]
          }
          if (value.indexOf('T') > -1) {
            return value.split('T')[0]
          }
          if (value.indexOf('-') > -1) {
            return value
          }
        }
        return this.parseTime ? this.parseTime(value, '{y}-{m}-{d}') : value
      },
      buildExpandExportTableData(columns, list) {
        const rows = [columns.map(item => item.label)]
        list.forEach(row => {
          rows.push([
            '主表',
            row.dealName || '',
            row.ofoworkName || '',
            '',
            '',
            row.initialBalance === undefined || row.initialBalance === null ? '' : row.initialBalance,
            row.debit === undefined || row.debit === null ? '' : row.debit,
            row.credit === undefined || row.credit === null ? '' : row.credit,
            row.amount === undefined || row.amount === null ? '' : row.amount
          ])
          ;(row.children || []).forEach(child => {
            rows.push([
              '明细',
              child.dealName || '',
              child.workType || '',
              this.formatExportDate(child.workDate),
              child.code || '',
              '',
              child.debit === undefined || child.debit === null ? '' : child.debit,
              child.credit === undefined || child.credit === null ? '' : child.credit,
              child.amount === undefined || child.amount === null ? '' : child.amount
            ])
          })
        })
        return rows
      },
      getExportConfig() {
        if (this.activeName === 'pay') {
          return {
            fileName: '往来应付.xlsx',
            sheetName: '往来应付',
            list: this.payList,
            columns: [
              { label: '记录类型', prop: 'rowType' },
              { label: '客户', prop: 'dealName' },
              { label: '活动/活动类型', prop: 'ofoworkName' },
              { label: '单据日期', prop: 'workDate' },
              { label: '单据号码', prop: 'code' },
              { label: '期初余额', prop: 'initialBalance' },
              { label: '本期发生金额', prop: 'debit' },
              { label: '本期已付金额', prop: 'credit' },
              { label: '往来金额', prop: 'amount' }
            ],
            withChildren: true
          }
        }
        if (this.activeName === 'restype_receivable') {
          return {
            fileName: '应收天数.xlsx',
            sheetName: '应收天数',
            list: this.payReport,
            columns: [
              { label: '客户', prop: 'deal_name' },
              { label: '活动', prop: 'name' },
              { label: '合计', prop: 'total' },
              ...this.columns.map(item => ({ label: item.name, prop: item.column }))
            ]
          }
        }
        if (this.activeName === 'restype_payable') {
          return {
            fileName: '应付天数.xlsx',
            sheetName: '应付天数',
            list: this.payReport,
            columns: [
              { label: '客户', prop: 'deal_name' },
              { label: '活动', prop: 'name' },
              { label: '合计', prop: 'total' },
              ...this.columns.map(item => ({ label: item.name, prop: item.column }))
            ]
          }
        }
        return {
          fileName: '往来应收.xlsx',
          sheetName: '往来应收',
          list: this.receiveList,
          columns: [
            { label: '记录类型', prop: 'rowType' },
            { label: '客户', prop: 'dealName' },
            { label: '活动/活动类型', prop: 'ofoworkName' },
            { label: '单据日期', prop: 'workDate' },
            { label: '单据号码', prop: 'code' },
            { label: '期初余额', prop: 'initialBalance' },
            { label: '本期发生金额', prop: 'debit' },
            { label: '本期已收金额', prop: 'credit' },
            { label: '往来金额', prop: 'amount' }
          ],
          withChildren: true
        }
      },
      handleExport() {
        const { fileName, sheetName, list, columns, withChildren } = this.getExportConfig()
        if (!list || !list.length) {
          this.$message.warning('暂无可导出数据')
          return
        }
        const tableData = withChildren
          ? this.buildExpandExportTableData(columns, list)
          : [
            columns.map(item => item.label),
            ...list.map(row => columns.map(item => row[item.prop] === undefined || row[item.prop] === null ? '' : row[item.prop]))
          ]
        const workSheet = XLSX.utils.aoa_to_sheet(tableData)
        this.setWorksheetCols(workSheet, tableData)
        const workBook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workBook, workSheet, sheetName)
        XLSX.writeFile(workBook, fileName)
      },
      filterHandler(value, row, column) {
        const property = column['property'];
        return row[property] === value;
      },
      // 获取应收列表
      getReceiveList(){
        this.loading = true
        this.$http.get(url.currentReceivable, {params: {
          accountType: this.accountType,
          dealName: this.dealName,
          selfownName: this.selfownName,
          startDate: this.date ? this.date[0] : '',
          endDate: this.date ? this.date[1] : '',
            nbzzId: this.nbzzId
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.receiveList = res.data.data.list.map(item => {
              return {
                ...item,
                filters: item.children.map(val => {
                  return {
                    text: val.workType,
                    value: val.workType
                  }
                })
                // children: [...(item.children || [])].sort((a, b) =>
                //   new Date(b.workDate) - new Date(a.workDate)
                // )
              }
            })
            this.receiveList.forEach(item => {
              item.filters = Array.from(new Set(item.filters.map(JSON.stringify)), JSON.parse)
            })
            // console.log(JSON.parse(JSON.stringify(this.receiveList)));

          }
        })
      },
      // 获取应付列表
      getPayList(){
        this.loading = true
        this.$http.get(url.currentPayable, {params: {
          dealName: this.dealName,
          accountType: this.accountType,
          startDate: this.date ? this.date[0] : '',
          endDate: this.date ? this.date[1] : '',
            nbzzId: this.nbzzId
        }}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            this.payList = res.data.data.list.map(item => {
              return {
                ...item,
                filters: item.children.map(val => {
                  return {
                    text: val.workType,
                    value: val.workType
                  }
                })
                // children: [...(item.children || [])].sort((a, b) =>
                //   new Date(b.workDate) - new Date(a.workDate)
                // )
              }
            })
            this.payList.forEach(item => {
              item.filters = Array.from(new Set(item.filters.map(JSON.stringify)), JSON.parse)
            })
          }
        })
      },
      inquire() {
        if(this.activeName == 'receive') {
          this.getReceiveList()
        }else if(this.activeName == 'pay') {
          this.getPayList()
        }else {
          // this.getPayList()
          this.$http.get(url.accountPeriodRept + this.nbzzId, {params: {
            jgts: this.jgts,
            type: this.activeName,
            dealName: this.dealName
          }}).then(res => {
            this.payReport = res.data.data.data || []
            // this.payReport[0].children[0].type2 = 1000
            // this.payReport[0].children[0].type4 = 99
            this.columns = res.data.data.columns || []
          })
        }

      },
      handleDetail(row) {
      },

      goProject(item) {
        this.$http.get(url.getWorkJumpId, {params: {ofoWorkId: item.ofoworkId}}).then(res => {
          // console.log(res);
          if(res.data.code == 200) {
            this.$router.push({
              path: '/project/' + res.data.data.ofoItemId,
            });
            this.$store.commit("setJumpData", {...res.data.data, turn: true})
            let obj = {
              path: "/project/" + res.data.data.ofoItemId,
              name: "proDetail",
              label: "项目详情",
              ofoItemId: res.data.data.ofoItemId,
              children: []
            };
            this.$store.commit('setSecondMenu', [])
            this.$store.commit("selectMenu", obj);
          }
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.contain {
  padding: 16px;
  background-color: #fff;
  border-radius: 11px;
}
</style>
